import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FilterDataService } from '../filter-data.service';

@Component({
  standalone: false,  
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.scss']
})
export class FilterItemInputComponent implements OnInit {

  myControl = new UntypedFormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  @Input() filterName: string; // Name of the menu filter being used.

  constructor(public dataService: FilterDataService) {}

  ngOnInit() {
    this.updateArray();
  }

  /**
   * Gets the menu items to be displayed in the dropdown and mapped to search for them in the input.
   */
  updateArray() {
    this.options = this.dataService.getOptions(this.filterName);
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filter(value))
    );
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  addFilter(id: string) { 
    this.dataService.curFilter().push(id);
    this.updateArray(); // Updates the possible options displayed to the user. 

  }

  removeFilter(id: number) {
    this.dataService.curFilter().splice(id, 1);
    this.updateArray();
  }
}